$(document).ready(function () {
  // Mobile Menu Trigger
  $(".burger").click(function () {
    document.body.classList.toggle("menu-opened");
  });

  // FitVids - Makes video embeds responsive
  $(".gh-content").fitVids();
});
